import { Modal, Button } from "react-bootstrap";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../common/Constant";
import { toastError, toastSuccess } from "../../common/Toast";
import axios from "axios";
import config from "../../config/config";
import { useEffect, useState } from "react";

const AddressModal = ({ open, handleClose, AddressEdit = {}, ID }) => {
  const loginUserId = localStorage.getItem("ID") || 0;
  const token = localStorage.getItem("Token") || "";

  const [formData, setFormData] = useState({
    Address1: "",
    Address2: "",
    City: "",
    StateProvince: "",
    Zip: "",
    Country: "",
  });

  const [isshippingdefault, setIsShippingDefault] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setFormData({
      Address1: AddressEdit?.Address1 || "",
      Address2: AddressEdit?.Address2 || "",
      City: AddressEdit?.City || "",
      StateProvince: AddressEdit?.StateProvince || "",
      Zip: AddressEdit?.Zip || "",
      Country: AddressEdit?.Country || "",
    });

    setIsShippingDefault(AddressEdit?.ShippingDefault === 1);
  }, [AddressEdit]);

  const handleChange = (e) => {
    console.log(e.target, "datafilll");

    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const hasAddressValue = [
      formData.Address1,
      formData.Address2,
      formData.City,
      formData.StateProvince,
      formData.Zip,
      formData.Country,
    ].some((field) => field && field.trim() !== "");

    if (!hasAddressValue) {
      toastError("At least one address field must be filled to save.");
      return;
    }

    const reqobj = {
      ID: AddressEdit?.ID || 0,
      CustomerId: ID,
      Add1: formData.Address1,
      Add2: formData.Address2,
      City: formData.City,
      StateProvince: formData.StateProvince,
      Zip: formData.Zip,
      Country: formData.Country,
      loginuserID: loginUserId,
      IsDefault: isshippingdefault ? 1 : 0,
    };

    setLoading(true);
    axios
      .post(
        `${config.customersBaseUrl}/customers/CustomerShipingAddByID`,
        reqobj,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleClose();
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Modal show={open} onHide={handleClose} size="lg" backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Customer Addresses</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <h5 className="mb-3">Address Book</h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Address 1</label>
              <textarea
                className="form-control form-control-sm"
                name="Address1"
                value={formData.Address1}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>Address 2</label>
              <textarea
                className="form-control form-control-sm"
                name="Address2"
                value={formData.Address2}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label>City</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="City"
                value={formData.City}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>State/Province</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="StateProvince"
                value={formData.StateProvince}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Zip Code</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="Zip"
                value={formData.Zip}
                onChange={handleChange}
                maxLength="6"
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>Country</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="Country"
                value={formData.Country}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group mb-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="IsDefault"
                checked={isshippingdefault}
                onChange={() => setIsShippingDefault(!isshippingdefault)}
              />
              <label className="form-check-label" htmlFor="IsDefault">
                Save Shipping Address as Default
              </label>
            </div>
          </div>

          <Modal.Footer>
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddressModal;
